module.exports = __webpack_public_path__ + "static/media/LoginFigura.5262db79.png";